var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"excom-icon"},[_c('img',{staticClass:"excom-icon-img",attrs:{"src":_vm.exicons[this.excom]}}),_vm._v(" "+_vm._s(_vm.text)+" "),_c('a-icon',{attrs:{"type":"retweet"},on:{"click":_vm.handChangePartner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }